module.exports = __webpack_public_path__ + "media/images/help/line/heading-point-1-46c4de566c8aa85df3c173b205323d0c.svg";